import {requestMs, requestFl} from "@helpers/api";

export const auth = {
  getInfo: (id) =>  requestMs.get(`api3/user/${id}`),
  getSalt: params => requestMs.post('/api3/user/salt', params),
  login: params => requestMs.post('/api3/user/login', params),
  flccLogin: params => requestFl.post('api/login', params)
};
